/** @typedef {import('./floorPlanDesignerState.js').DesignerState} DesignerState */

import { getPointById } from './floorPlanDesignerState.js';

export const NODE_DIAMETER_METERS = 0.1;
export const NODE_RADIUS_METERS = 0.05;

/**
 * Visual circle center/radius for a centerline pivot node (does not change stored coordinates).
 * @param {DesignerState} state
 * @param {string} pointId
 * @param {number} pixelsPerMeter
 * @returns {{ x: number; y: number; radiusPx: number }}
 */
export function getNodeVisualCenter(state, pointId, pixelsPerMeter) {
  const pt = getPointById(state, pointId);
  if (!pt) {
    return { x: 0, y: 0, radiusPx: 0 };
  }

  const ppm = pixelsPerMeter > 0 ? pixelsPerMeter : 100;
  const radiusPx = NODE_RADIUS_METERS * ppm;
  return { x: pt.x, y: pt.y, radiusPx };
}
